import React from "react";
import { RoadblockStatus, TRoadblockAwaitableEntity, TRoadblockStatus } from "../../../../../domain/codecs/form/RoadblockForm";
import { TRoadblockListView } from "../../../models/RoadblockListView";
import { TPlainUser } from "../../../../../domain/codecs/User";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { CRMRoadblockTableListItem } from "../CRMRoadblockTableListItem/CRMRoadblockTableListItem";
import { CRMRoadblockStatusLabel } from "../CRMRoadblockStatusLabel/CRMRoadblockStatusLabel";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { CRMEmptyPlaceholder } from "../../Simple/CRMEmptyPlaceholder/CRMEmptyPlaceholder";
import { Background } from "../../BuildingBlocks/Background";

type TRoadblocks = Array<TRoadblockListView>;
type TRoadblocksGroup = Array<[TRoadblockStatus, Array<TRoadblockListView>]>;
const RoadblockGroups: Array<TRoadblockStatus> = RoadblockStatus.values;

type TRoadblockTableListProps = {
    roadblocks: TRoadblocks;
    assignableUsers: Array<TPlainUser>;
    awaitableEntities: Array<TRoadblockAwaitableEntity>;
    onClick: (roadblockId: string) => void;
    onAssign: (payload: { roadblock_id: string, assigned_to_user_id: string }) => void;
    onAwait: (payload: { roadblock_id: string, awaitable_entities_id: string, days_override: number | null }) => void;
    onCancelAwait: (payload: { roadblock_id: string }) => void;
};

export const CRMRoadblockTableList = (props: React.PropsWithChildren<TRoadblockTableListProps>): JSX.Element => {
    
    const getRoadblocksByStatus = (matchingStatus: TRoadblockStatus): Array<TRoadblockListView> =>
        props.roadblocks.filter(({ status }) => status === matchingStatus)
    ;

    const roadblocksGrouped: TRoadblocksGroup = RoadblockGroups.reduce(
        (sum, status) => {
            const roadblocks = getRoadblocksByStatus(status);
            return roadblocks.length > 0 ? 
                sum.concat([[status, roadblocks]])
                : sum
            ;
        },
        [] as TRoadblocksGroup
    );

    return (
        <div>
            {props.roadblocks.length > 0 &&
                <Background padding={`0px 0px ${CRMSpacing.X_LARGE}`}>
                    <SpacingColumn spacing={CRMSpacing.X_LARGE}>
                        {roadblocksGrouped.map(([groupStatus, groupRoadblocks], groupIndex) => (
                            <SpacingColumn
                                key={groupIndex}
                                spacing={CRMSpacing.MEDIUM}
                            >
                                <CRMRoadblockStatusLabel
                                    status={groupStatus}
                                />
                                
                                <SpacingColumn>
                                    {groupRoadblocks.map((item) => (
                                        <CRMRoadblockTableListItem
                                            key={item.id}
                                            item={item}
                                            assignableUsers={props.assignableUsers}
                                            awaitableEntities={props.awaitableEntities}
                                            onClick={props.onClick}
                                            onAssign={props.onAssign}
                                            onAwait={props.onAwait}
                                            onCancelAwait={props.onCancelAwait}
                                        />
                                    ))}
                                </SpacingColumn>
                            </SpacingColumn>
                        ))}
                    </SpacingColumn>
                </Background>
            }
            
            {props.roadblocks.length === 0 &&
                <Background padding={`${CRMSpacing.X_LARGE} ${CRMSpacing.LARGE}`}>
                    <CRMEmptyPlaceholder
                        iconSize="70px"
                        textGap={CRMSpacing.TINY}
                    >
                        This case has no roadblocks.
                    </CRMEmptyPlaceholder>
                </Background>
            }
        </div>
    );
};
